// extracted by mini-css-extract-plugin
module.exports = {"root":"SpaceSize__root___3hGvw","linked":"SpaceSize__linked___1jaEH","linkingWord":"SpaceSize__linkingWord___3rJqm"};